<script>
import displaySettings from "@/mixin/displaySettings";

export default {
    name: "PolicyReissueSuccessDialog",
    props: ['dialogVisible'],
    mixins: [displaySettings],
		methods: {
			reloadPage() {
                this.$emit('update:dialogVisible', false);
				//location.reload(false)
			}
		},
}
</script>

<template>
    <div class="policy-cancel">
        <el-dialog
            :width="isMobile ? '100%' : '20%'"
            :visible.sync="dialogVisible"
            center
            top="30vh"
            custom-class="p-4"
        >
            <div slot="title">
                <div class="title mb-2">Заявка на переоформлення полісу отримана, очікуйте зміни статусу в історії замовлень.</div>
            </div>
            <div class="description">
                Після переоформлення договір надійде на пошту, а також його можна завантажити в “історії замовлень”
            </div>
            <div slot="footer">
                <el-row>
                    <el-col>
                        <el-button type="primary" class="w-100" @click="reloadPage">Продовжити</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>

</style>
